/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Zod_SchemasInputs */

const en_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zod schemas`)
};

const ar_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخططات Zod`)
};

const bn_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zod স্কিমা`)
};

const de_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zod-Schemata`)
};

const es_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquemas Zod`)
};

const fr_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schémas Zod`)
};

const pt_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquemas Zod`)
};

const zh_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zod 模式`)
};

const tr_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zod şemaları`)
};

const ru_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схемы Зода`)
};

const pl_svchip_zod_schemas = /** @type {(inputs: Svchip_Zod_SchemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schematy Zoda`)
};

/**
* | output |
* | --- |
* | "Zod schemas" |
*
* @param {Svchip_Zod_SchemasInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_zod_schemas = /** @type {((inputs?: Svchip_Zod_SchemasInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Zod_SchemasInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_zod_schemas(inputs)
	if (locale === "bn") return bn_svchip_zod_schemas(inputs)
	if (locale === "de") return de_svchip_zod_schemas(inputs)
	if (locale === "es") return es_svchip_zod_schemas(inputs)
	if (locale === "fr") return fr_svchip_zod_schemas(inputs)
	if (locale === "pt") return pt_svchip_zod_schemas(inputs)
	if (locale === "zh") return zh_svchip_zod_schemas(inputs)
	if (locale === "tr") return tr_svchip_zod_schemas(inputs)
	if (locale === "ru") return ru_svchip_zod_schemas(inputs)
	if (locale === "pl") return pl_svchip_zod_schemas(inputs)
	return en_svchip_zod_schemas(inputs)
});